export const translationRO = {
  'acronym': 'JRMC',
  'magazine_title': 'Jurnalul Român de Management Cultural',
  'department_name': 'Departamentul de Artă Teatrală',
  'cavas_research_center': 'Centrul de Cercetări Avansate în Domeniul Artelor Spectacolului',
  'indexed-by': 'Publicație indexată în:',
  'copyright': 'Toate drepturile rezervate',
  affiliation: {
    'lucian_blaga_university_of_sibiu': 'Universitea „Lucian Blaga” din Sibiu',
    'new_sorbonne_university_paris_3': 'Universitea Sorbonne Nouvelle - Paris III',
    'leeds_beckett_university': 'Universitatea Leeds Beckett',
  },
  title: {
    'president': 'PREȘEDINTE',
    'editor_in_chief': 'REDACTOR-ȘEF',
    'associate_editor': 'EDITOR ASOCIAT',
    'managing_editor': 'EDITOR-ȘEF',
    'web_and_print': 'WEB & PRINT',
  },
  position: {
    'univ_professor': 'Prof. univ. dr.',
    'assoc_professor': 'Asist. univ. dr.',
    'phd_student': 'Doctorand'
  },
  menu: {
    'about': 'Despre',
    'boards': 'Comitete',
    'instructions': 'Instrucțiuni',
    'review': 'Analiză',
    'call_for_papers': 'Call For Papers',
    'archive': 'Arhivă',
    'contact': 'Contact',
  },
  publicationList: {
    title: 'Titlu',
    year: 'Anul publicației',
    download: 'Descarcă',
  },
  pages: {
    index: {
      description: 'Jurnalul Român de Management Cultural este o revistă academică interdisciplinară și interculturală, editată de Universitatea Lucian Blaga din Sibiu, prin Centrul de Cercetări Avansate în Domeniul Artelor Spectacolului. Revista acoperă aspecte din domeniul managementului cultural, punând accent pe managementul artistic și al evenimentelor culturale, festivaluri, regenerare urbană / rurală și artă comunitară. JRMC publică articole scrise de renumiți manageri și teoretici, dar încurajează, de asemenea, tinerii cercetători să-și prezinte articolele. Scopul principal al JRMC este de a încuraja diseminarea teoretică a activității practice în cazul specialiștilor angajați în managementul cultural.',
      latest_release_authors: 'În acest număr semnează:',
      partnership: {
        'part1': 'Publicaţie editată de',
        'part2': 'CENTRUL DE CERCETĂRI AVANSATE ÎN DOMENIUL ARTELOR SPECTACOLULUI',
        'part3': 'în colaborare cu',
        'part4': 'TEATRUL NAŢIONAL „RADU STANCA” SIBIU',
        'part5': 'FESTIVALUL INTERNAȚIONAL DE TEATRU DE LA SIBIU',
        'part6': 'DEPARTAMENTUL DE ARTĂ TEATRALĂ din FACULTATEA DE LITERE ŞI ARTE',
        'part7': 'UNIVERSITATEA „LUCIAN BLAGA” DIN SIBIU',
        'part8': 'și',
        'part9': 'EDITURA UNIVERSITĂŢII „LUCIAN BLAGA” DIN SIBIU'
      }
    },
    boards: {
      'sicentific_board': 'Comitet Ştiinţific',
      'walk_of_fame': 'Aleea Celebrităților',
      'editorial_board': 'Comitet Editorial'
    },
    instructions: {
      'part1': 'În vederea asigurării unei structuri unitare, dar și a unei calități formale și de conținut pe care revistele noastre le cer, vă rugăm să luați la cunoștință următoarele aspecte privitoare la exigențele de redactare.',
      'part2': 'Articolele vor fi salvate în formatul .doc sau .docx.',
      'part3': 'Studii / articole cu caracter științific din zona artelor spectacolului a artelor vizuale sau a managementului cultural (între 5 și 15 pagini);',
      'part4': 'Analiză / cronică de spectacol sau de film (între 5 și 15 pagini).',
      'part5': 'Textele vor fi redactate în română, engleză sau franceză și vor fi însoțite de un rezumat (de 90-100 de cuvinte) și de 5 cuvinte-cheie în limba engleză.',
      'part6': 'Numele autorului, precum și gradul și afilierea sa, va fi scris pe prima pagină, pe primul rând și va fi însoțit de o notă de subsol în care vor fi precizate, într-o prezentare succintă a autorului (funcția, pregătirea profesională și instituția de afiliere).',
      'part7': 'Sub titlul textului scris cu Bold, care va fi fixat central pe prima pagină, va fi așezat rezumatul, apoi cuvintele cheie.',
      'part8': 'Textele vor fi redactate pe pagină A4, în Times New Roman, mărimea corpului de literă fiind de 12, la 1,5 rânduri, Justify. Toate marginile paginii trebuie să fie de 2,5cm. ',
      'part9': 'Citatele vor fi introduse între ghilimele și se va indica sursa în note de subsol (footnotes), după următoarea formulă: Numele complet al autorului, Titlul cărții (în italic), Traducătorul (dacă este cazul), Editura, Locul publicării, Anul publicării, Pagina. De exemplu: Eugenio Barba, Teatru: singurătate, meșteșug, revoltă. Traducere de Doina Condrea Derer, Editura Nemira, București, 2013, p. 136.',
      'part10': 'În cazul unor citări preluate din surse web, în nota se subsol se va specifica autorul și titlul articolului și se va atașa link-ul care trimite la informația respectivă, precum și data accesării site-ului.',
      'part11': 'Textele trebuie să prezinte, la sfârșit, o bibliografie în ordine alfabetică, redactată după cum urmează:',
      'part12': 'În cazul cărților: Numele autorului, Prenumele autorului, Titlul cărții, Editura, Locul publicării, Anul publicării.',
      'part13': 'În cazul articolelor din ziare sau reviste: Numele autorului, Prenumele autorului, Titlul articolului, Titlul revistei / ziarului, Numărul, Luna apariției, Locul apariției, Anul de apariție.',
      'part14': 'În cazul articolelor WEB vor fi precizate: Numele autorului, Titlul articolului, Anul publicării, Link către articol, data accesării site-ului.',
      'part15': 'Adresa pe care se vor trimite textele este andrei.serban@ulbsibiu.ro.'
    },
    review: {
      'part1': 'Jurnalul Român de Management Cultural este o publicație academică ce utilizează principiul review-ului arbitrar.',
      'part2': 'Toate lucrările luate în considerare pentru a face obiectul acestei reviste sunt recenzate în mod anonim de cel puțin doi revieweri externi. Reviewerii sunt afiliați unei instituții diferite de cea a autorului.',
      'part3': 'Procesul de recenzare durează între 4 și 6 săptămâni.',
    },
    call_for_papers: {
      'part1': 'Dragi colegi și colaboratori,',
      'part2': 'În vederea publicării revistei Jurnalul Român de Management Cultural (anul {{year}}, nr. {{issueNumber}}), vă invităm să vă trimiteți articolele, studiile și cronicile până la data de {{date}}.',
      'part3': 'Pentru mai multe detalii privitoare la conținutul și forma materialelor trimise, consultați secțiunea Instrucțiuni pentru Autori.',
    },
    archive: {
      'publishing': 'în curs de publicare',
    },
    contact: {
      'part1': 'Universitatea „Lucian Blaga” din Sibiu',
      'part2': 'Facultatea de Litere şi Arte',
      'part3': 'B-dul Victoriei, nr. 5-7, 550024, Sibiu, România',
      'part4': 'https://artsib.ro',
      'part5': 'http://reviste.ulbsibiu.ro/jas',
      'part6': 'ion.tomus@ulbsibiu.ro',
      'part7': 'andrei.serban@ulbsibiu.ro'
    }
  }
}